var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRightIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.60983 10.0152C7.46339 9.86872 7.46339 9.63128 7.60983 9.48483L10.7197 6.375H0.375C0.167893 6.375 0 6.20711 0 6C0 5.79289 0.167893 5.625 0.375 5.625H10.7197L7.60983 2.51517C7.46339 2.36872 7.46339 2.13128 7.60983 1.98483C7.75628 1.83839 7.99372 1.83839 8.14017 1.98483L11.8902 5.73484C11.9261 5.77079 11.9532 5.81223 11.9715 5.85646C11.9899 5.90067 12 5.94915 12 6C12 6.05085 11.9899 6.09933 11.9715 6.14354C11.9532 6.18777 11.9261 6.22921 11.8902 6.26516L8.14017 10.0152C7.99372 10.1616 7.75628 10.1616 7.60983 10.0152Z",
    fill: "#2251FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/arrow-right-icon.f0cbe5d7d24cd7373f3b51a04e8b9393.svg";
export { ForwardRef as ReactComponent };